import {clientConfig} from '@modifi/client-config'

const getUserConsentKey = () => {
  const suffix = clientConfig.get('app_env_long', '')
  return `user-consent${suffix.includes('production') ? '' : `-${suffix}`}`
}

export default getUserConsentKey
